export const AUTH_USER = 'auth_user';